import { render, staticRenderFns } from "./ProductsAndServices.vue?vue&type=template&id=491db819&scoped=true&"
import script from "./ProductsAndServices.ts?vue&type=script&lang=ts&"
export * from "./ProductsAndServices.ts?vue&type=script&lang=ts&"
import style0 from "./ProductsAndServices.vue?vue&type=style&index=0&id=491db819&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491db819",
  null
  
)

export default component.exports